import { Separator } from "@components/ui/separator";
import { SidebarTrigger } from "@components/ui/sidebar";
import { AdminGlobalSearch } from "@user-management-context/primary/shared/admin-global-search/admin-global-search.container";

export const AdminTopBarContent = () => {
  return (
    <div className="mb-4 bg-sidebar">
      <div className="flex items-center p-2">
        <SidebarTrigger />
        <div className="ml-14 w-full md:w-auto">
          <AdminGlobalSearch />
        </div>
      </div>
      <Separator />
    </div>
  );
};
